import parseQueryString from 'utils/parseQueryString';
import { navigateInternally } from 'utils/bolt';
import Store from 'store/store';
export * from 'helpers/earlyAccess.js';

export const checkEarlyAccess = () => {
	// early access ends April 19, 9:00 UTC / 2:00a PT April 19
	const earlyAccessOver = Date.now() > Date.UTC(2023, 3, 19, 9, 0);
	if (earlyAccessOver) {
		return;
	}
	const query = parseQueryString();
	if (query?.['CINEPLEXearly-access']) {
		Store.emit('EARLY_ACCESS_WINDOW');
		return;
	}
	navigateInternally('boltHome');
};